module.exports = __webpack_public_path__ + "static/media/jdbc.63c9f90f.png";